import React, {Component} from 'react'
import {message, Form, Row, Col} from 'antd'
import {reqPublicOptRecord, getPublicOrderDetail} from '../../api';
import {subTimeStr, subStr} from "../../utills/subStringUtill";
import {DEFAULT_CUSTOMS_CODE, DELIVERY_TYPE_MIX}from '../../utills/constants'
import './delivery-step.less'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
//只有查看功能
class DeliveryPublicStep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: [],
            processShow: false,
            visible: false,
        }
    }

    componentWillReceiveProps(nextProps) {
        const {orderNo} = this.state;
        const newdata = nextProps.orderNo;
        if (orderNo !== newdata) {
            this.setState({orderNo: newdata});
            const a = this.getOrderShortFunc(newdata);
            Promise.all([a]).then(() => {
                this.getOptRecord(newdata);
            })
        }
    }

    getOrderShortFunc = async (orderNo) => {
        let result = await getPublicOrderDetail(orderNo)
        if (result.code === 200) {
            this.setState({
                internationalEndCity: result.data.internationalEndCity,
                commitDt: result.data.commitDt,
                deliveryType: result.data.deliveryType,
                customsPort: result.data.customsPort,
                checkDt: result.data.checkDt,
                transitEstDt: result.data.transitEstDt,
                warehouseEstDt: result.data.warehouseEstDt,
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    };
    getOptRecord = async (orderNo) => {
        const result = await reqPublicOptRecord(orderNo);
        if (result.code == '200') {
            const {deliveryType,} = this.state;
            //状态：collect:揽货,arrive:到达山口,declare:报关,systemPass:海关系统放行,pass:实货放行,transport:转运,dstkArrive:到达多斯特克,
            //     dstkOut:多斯特克出发,arriveDuisburg:到达目的城市,leaveDuisburg:清关仓库,destination:到达目的地)
            const data = {};
            for (let d of result.data) {
                if (!d.indx) {
                    data[d.optType] = d.optDt;
                }
            }
            //新疆班列第二个点隐藏了，增加一个空点
            if (deliveryType === 'X') {
                result.data.splice(1, 0, {});
            }
            //css样式中第三个点隐藏了，所以增加了一个空点
            result.data.splice(2, 0, {});
            this.setDivs(result.data);
            this.setState(data);
        }
    };
    setDivs = (steps) => {
        const divs = (steps || []).map(d =>
            <div className={d.optDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className='info'>
                    <div className="circle"><i></i></div>
                    <div className="title">{d.optName}</div>
                    <div className="time1">{d.optDt ? subStr(d.optDt) : ''}</div>
                    <div className="time2">{d.optDt ? subTimeStr(d.optDt) : ''}</div>
                </div>
            </div>
        );
        this.setState({divs, steps})
    };
    spreadOpt = () => {
        const {processShow} = this.state;
        if (processShow) {
            this.setState({processShow: false})
        } else {
            this.setState({processShow: true})
        }
    };

    render() {
        const {processShow, commitDt, divs, deliveryType, checkDt,} = this.state;
        const className = deliveryType === 'X' ? ' hide' : '';
        return (
            <div>
                <Row className='track-info-item'>
                    <Col span={6} xs={24} md={6}>
                        <span className='label'>查验时间 : </span>
                        <span>{checkDt}</span>
                    </Col>
                </Row>
                <div className={processShow ? "processBox processShow" + className : 'processBox' + className}>
                    <div className={commitDt ? 'proceIteam finish' : 'proceIteam' }>
                        <div className="info">
                            <div className="circle"><i></i></div>
                            <div className="title">货运订单</div>
                            <div className="time1">{commitDt ? subStr(commitDt) : ''}</div>
                            <div className="time2">{commitDt ? subTimeStr(commitDt) : ''}</div>
                        </div>
                    </div>
                    {divs}
                    <div className="processShowBtn" onClick={this.spreadOpt}>
                        <span className="open">展开</span>
                        <span className="closed">收起</span>
                    </div>
                </div>
            </div>
        )
    }
}
const DeliveryStepPublicForm = Form.create()(DeliveryPublicStep);
export default DeliveryStepPublicForm;